import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [locale, setLocaleState] = useState('de');
  const [isClient, setIsClient] = useState(false);

  // Prüfe ob wir im Browser sind
  useEffect(() => {
    setIsClient(true);
    
    // Nur im Browser localStorage lesen
    if (typeof window !== 'undefined' && window.localStorage) {
      const saved = localStorage.getItem('selectedLanguage');
      if (saved && (saved === 'de' || saved === 'en')) {
        setLocaleState(saved);
      }
    }
  }, []);

  const setLocale = (newLocale) => {
    setLocaleState(newLocale);
    
    // Nur im Browser localStorage schreiben
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('selectedLanguage', newLocale);
    }
    
    console.log('Language changed to:', newLocale);
  };

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
